export enum RepositoryStrategyEnum {
  NETWORK_ONLY,
  LOCAL_ONLY,
  LOCAL_FIRST,
  NETWORK_FIRST,
  MOCK
}
